/**
 * Authentication Redux slice.
 *
 * Tracks the authenticated user's profile data.  Token pairs (access/refresh)
 * are persisted separately in `localStorage` via `local-storage-handler`.
 *
 * - `loginReducer`  — populated after `/oauth/login`.
 * - `authReducer`   — sets `isAuthenticated` after the token exchange.
 */
import { createSlice } from "@reduxjs/toolkit";

/** Shape of the authentication state tree. */
export interface AuthState {
  isAuthenticated: boolean;
  email: string;
  name: string;
  mobile: string;
  resellerId: number;
  username: string;
}

const initialAuthState: AuthState = {
  isAuthenticated: !!localStorage.getItem("access_token"),
  email: "",
  name: "",
  mobile: "",
  resellerId: 0,
  username: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    loginReducer: (state, action) => {
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.mobile = action.payload.mobile;
      state.resellerId = action.payload.resellerId;
      state.username = action.payload.username;
    },
    authReducer: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
    },
  },
});

export const { loginReducer, authReducer } = authSlice.actions;
export default authSlice.reducer;
